import { useEffect } from "react";

/** Lightweight tab behaviour for Webflow-exported tab markup */
export default function useWebflowTabs() {
  useEffect(() => {
    const tabBlocks = document.querySelectorAll(".w-tabs");
    const cleanups = [];

    tabBlocks.forEach((tabsEl) => {
      /* Recently placed month tabs are controlled by React state */
      if (tabsEl.closest("#recently-placed")) return;

      const menu = tabsEl.querySelector(".w-tab-menu");
      const content = tabsEl.querySelector(".w-tab-content");
      if (!menu || !content) return;

      const links = Array.from(menu.querySelectorAll(".w-tab-link"));
      const panes = Array.from(content.querySelectorAll(".w-tab-pane"));
      if (!links.length || !panes.length) return;

      function activate(index) {
        links.forEach((link, i) => {
          link.classList.toggle("w--current", i === index);
        });
        panes.forEach((pane, i) => {
          pane.classList.toggle("w--tab-active", i === index);
        });
      }

      const handlers = links.map((link, index) => {
        const handler = (e) => {
          e.preventDefault();
          activate(index);
        };
        link.addEventListener("click", handler);
        return () => link.removeEventListener("click", handler);
      });

      cleanups.push(...handlers);
      activate(links.findIndex((l) => l.classList.contains("w--current")) || 0);
    });

    return () => cleanups.forEach((fn) => fn());
  }, []);
}
